module.exports = __webpack_public_path__ + "static/media/16UNODC27.fbe7e52a.jpg";